import React, { Component } from "react";
import { connect } from "react-redux";
import { Container, Row, Col, Spinner, Card } from "react-bootstrap";
import { PortletBody } from "../../../partials/content/Portlet";
import SummaryCards from "./SummaryCards";
import TaskList from "./TaskList";
import PsActivity from "./PsActivity";
import PsActivityMap from "./PsActivityMap";
import PsSummary from "./PsSummary";
import * as constants from '../../../constants';
import { psProductivityDashboardServices } from "./PsProductivityDashboard.services";
import FilterComponent from "../../../partials/layout/FilterComponent";
import { commonServices } from "../../../commonServices/commonServices";
import { datePlusOneDay } from "../../../../_metronic";

class PsProductivityDashboard extends Component {
    constructor(props) {
        super(props);

        this.state = {
            dashboardData: {},
            taskPage: 1,
            taskLimit: 10,

            activityPage: 1,
            activityLimit: 10,

            summaryPage: 1,
            summaryLimit: 10,
            isFetching: false,
            formattedCities: [],
            selectedCities: []
            // fromDate: "undefined",
            // toDate: "undefined",
        };
    }

    async componentDidMount() {
        await this.getCities();
        await this.getManagersAndSupervisors();
        await this.getPsActivityData();
    }

    getCities = async () => {
        try {
            const data = {
                pmsOperationStatus: "YES"
            };

            const result = await commonServices.getCities(data);

            if (result && result.status === 200) {
                const cities = result?.data?.cities || [];

                const allowedCityIds =
                    this.props.userDetails?.cityId || [];

                let filteredCities = cities;

                if (
                    Array.isArray(allowedCityIds) &&
                    allowedCityIds.length > 0
                ) {
                    filteredCities = cities.filter(city =>
                        allowedCityIds.includes(city.id)
                    );
                }

                const formattedCities = filteredCities.map(city => ({
                    label: city.name,
                    value: city.id
                }));

                let preSelectedCities = [];
                let cityIds = [];

                if (formattedCities.length > 0) {
                    preSelectedCities = [formattedCities[0]];
                    cityIds = [formattedCities[0].value];
                }

                await this.setState({
                    formattedCities,
                    preSelectedCities,
                    selectedCities: preSelectedCities,
                    cityIds
                });
            }
        } catch (error) {
            console.log("Cities Error:", error);
        }
    };

    getManagersAndSupervisors = async () => {
        const data = {
            userRoleCodes: ['PROPERTY_MANAGER', 'PROPERTY_SUPERVISOR', 'MOVE_IN_MANAGER'],
        }
        const result = await commonServices.getUserListData(data);
        if (result && result.status === 200) {
            const propertyManagers = result.data.users.filter(user =>
                user.userRoleCodes?.includes("PROPERTY_MANAGER")
            );
            const propertySupervisors = result.data.users.filter(user =>
                user.userRoleCodes?.includes("PROPERTY_SUPERVISOR")
            );
            const moveInManagers = result.data.users.filter(user =>
                user.userRoleCodes?.includes("MOVE_IN_MANAGER")
            );
            await this.setState({ propertyManagers: propertyManagers, propertySupervisors: propertySupervisors, moveInManagers: moveInManagers })
        }
    }

    setSelected = async (selectedCities) => {
        const cityIds = selectedCities.map(
            city => city.value
        );

        await this.setState({
            selectedCities,
            cityIds
        });

        await this.getPsActivityData();
    };

    getPsActivityData = async () => {
        try {
            this.setState({ isFetching: true });
            const { cityIds, propertyManagerId, assigneeId, moveInManagerId, minimumDatetime, maximumDatetime, jobType } = this.state;
            let newmaximumDatetime = maximumDatetime && datePlusOneDay(maximumDatetime);

            const params = {
                cityIds,
                moveInManagerId: moveInManagerId !== '0' ? moveInManagerId : undefined,
                propertyManagerId: propertyManagerId !== '0' ? propertyManagerId : undefined,
                propertySupervisorId: assigneeId !== '0' ? assigneeId : undefined,
                fromDate: minimumDatetime || undefined,
                toDate: newmaximumDatetime || undefined,
                jobType


            };
            const result = await psProductivityDashboardServices.getPsActivityData(params);

            if (result && result.status === 200) {
                this.setState({
                    dashboardData: result.data || {}
                });
            }
        } catch (error) {
            console.log("Dashboard API Error:", error);
        } finally {
            this.setState({
                isFetching: false
            });
        }
    };

    paginateData = (data, page, limit) => {
        const start = (page - 1) * limit;
        const end = start + limit;

        return data.slice(start, end);
    };

    handleTaskPageChange = (page) => {
        this.setState({
            taskPage: page
        });
    };

    handleActivityPageChange = (page) => {
        this.setState({
            activityPage: page
        });
    };

    handleSummaryPageChange = (page) => {
        this.setState({
            summaryPage: page
        });
    };

    handleFilterChildData = async (childData) => {
        if (childData) {
            this.setState({ ...childData, minimumDatetime: childData.minimumExecutionDate, maximumDatetime: childData.maximumExecutionDate });
            await this.resetPage();
            await this.getPsActivityData();
            await this.getCities();
            await this.getManagersAndSupervisors();
        }
    }

    resetPage = async () => {
        await this.setState({
            page: 1,
            offset: 0,
            //limit: 10,
        })
    }

    render() {
        const {
            dashboardData,
            isFetching,
            taskPage,
            taskLimit,
            activityPage,
            activityLimit,
            summaryPage,
            summaryLimit,
            propertySupervisors,
            propertyManagers,
            moveInManagers,
            assigneeId,
            propertyManagerId,
            moveInManagerId,
            minimumDatetime,
            maximumDatetime,
        } = this.state;

        const {
            summary = {},
            taskList = [],
            psActivity = [],
            mapData = [],
            psSummary = []
        } = dashboardData;

        const paginatedTaskList = taskList.slice(
            (taskPage - 1) * taskLimit,
            taskPage * taskLimit
        );

        const paginatedPsActivity = psActivity.slice(
            (activityPage - 1) * activityLimit,
            activityPage * activityLimit
        );

        const paginatedPsSummary = psSummary.slice(
            (summaryPage - 1) * summaryLimit,
            summaryPage * summaryLimit
        );

        if (isFetching) {
            return (
                <div className="text-center mt-5">
                    <Spinner animation="border" />
                    <p className="mt-2">Loading dashboard...</p>
                </div>
            );
        }

        return (
            <Container fluid className="dashboard-container">

                {/* Header */}
                <div className="dashboard-header mb-4">
                    <h2>Property Supervisors Activity Dashboard</h2>
                    <p className="text-muted">
                        Track property supervisor activity, task completion,
                        travel routes and summary.
                    </p>
                </div>
                {/* Summary Cards */}
                <SummaryCards summary={summary} />
                <PortletBody>
                    <Card>
                        <FilterComponent
                            propertyManagers={propertyManagers}
                            propertySupervisors={propertySupervisors}
                            assigneeId={assigneeId}
                            propertyManagerId={propertyManagerId}
                            moveInManagers={moveInManagers}
                            moveInManagerId={moveInManagerId}
                            minimumExecutionDate={minimumDatetime}
                            maximumExecutionDate={maximumDatetime}
                            formattedCities={this.state.formattedCities}
                            preSelectedCities={this.state.preSelectedCities}
                            jobTypeData={constants.JOB_TYPE}
                            selectedJobType={this.state.jobType}
                            // recordsPerPage={constants.RECORDS_PER_PAGE}
                            // selectedRecordValue={this.state.limit}
                            filterParentCallback={this.handleFilterChildData}
                        />
                    </Card>
                </PortletBody>
                {/* Task + Map */}
                {/* <Row className="mt-4">
                    <Col md={7}>
                        <TaskList taskList={taskList} />
                    </Col>

                    <Col md={5}>
                        <PsActivityMap mapData={mapData} />
                    </Col>
                </Row> */}

                {/* Activity + Summary */}
                {/* <Row className="mt-4">
                    <Col md={8}>
                        <PsActivity psActivity={psActivity} />
                    </Col>

                    <Col md={4}>
                        <PsSummary psSummary={psSummary} />
                    </Col>
                </Row> */}

                <Row className="mt-4">
                    <Col md={7}>
                        <TaskList
                            taskList={paginatedTaskList}
                            totalRecords={taskList.length}
                            currentPage={taskPage}
                            limit={taskLimit}
                            onPageChange={this.handleTaskPageChange}
                        />
                    </Col>

                    <Col md={5}>
                        <PsActivityMap mapData={mapData} />
                    </Col>
                </Row>

                <Row className="mt-4">
                    <Col md={8}>
                        <PsActivity
                            psActivity={paginatedPsActivity}
                            totalRecords={psActivity.length}
                            currentPage={activityPage}
                            limit={activityLimit}
                            onPageChange={this.handleActivityPageChange}
                        />
                    </Col>

                    <Col md={4}>
                        <PsSummary
                            psSummary={paginatedPsSummary}
                            totalRecords={psSummary.length}
                            currentPage={summaryPage}
                            limit={summaryLimit}
                            onPageChange={this.handleSummaryPageChange}
                        />
                    </Col>
                </Row>
            </Container>
        );
    }
}

const mapStateToProps = state => ({
    userDetails: state.auth && state.auth.user
});

export default connect(
    mapStateToProps,
    null
)(PsProductivityDashboard);

// export default PsProductivityDashboard;